import { useCallback } from "react";
import {
  runEEGViewerPlaybackTick,
  type EEGViewerPlaybackTickDeps,
} from "../components/eegViewerPlaybackTick";

export type { EEGViewerPlaybackTickRefs } from "../components/eegViewerPlaybackTick";

export function useEEGPlaybackTick(deps: EEGViewerPlaybackTickDeps) {
  const {
    refs,
    currentRecordingId,
    playbackPerf,
    recordPlaybackPerfEvent,
    getEffectiveBufferSize,
    getPrefetchThreshold,
    getAdvanceChunk,
    schedulePlaybackDataWindowStart,
    queuePlaybackPrefetch,
    recordPauseBoundaryEvent,
    setRecordingDuration,
    startDataWindowTransition,
    alignWindowStartToBackend,
    markLiveTopographyBufferUpdated,
  } = deps;

  return useCallback(
    (rawNextTime: number, deltaMs: number) => {
      runEEGViewerPlaybackTick(deps, rawNextTime, deltaMs);
    },
    [
      refs,
      currentRecordingId,
      playbackPerf,
      recordPlaybackPerfEvent,
      getEffectiveBufferSize,
      getPrefetchThreshold,
      getAdvanceChunk,
      schedulePlaybackDataWindowStart,
      queuePlaybackPrefetch,
      recordPauseBoundaryEvent,
      setRecordingDuration,
      startDataWindowTransition,
      alignWindowStartToBackend,
      markLiveTopographyBufferUpdated,
    ],
  );
}
